import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { getTheme, toggleTheme } from "@/lib/theme";

/**
 * Kleiner Umschalter für Hell-/Dunkelmodus. Liest den aktuellen Zustand von der
 * <html>-Klasse (von public/theme-init.js beim Laden gesetzt) und spiegelt Klicks
 * sofort in DOM + localStorage.
 */
export default function ThemeToggle({ className = "", size = 16 }) {
  const [theme, setThemeState] = useState("light");

  useEffect(() => {
    setThemeState(getTheme());
  }, []);

  const onClick = () => setThemeState(toggleTheme());

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="theme-toggle"
      aria-label="Farbschema wechseln"
      className={`inline-flex items-center justify-center rounded-full transition-colors ${className}`}
    >
      {theme === "dark" ? <Sun size={size} /> : <Moon size={size} />}
    </button>
  );
}
